module.exports = __webpack_public_path__ + "static/media/habitation-login.77d38a62.svg";